export const MEETING_NOTIFICATIONS_VIEW_PREFERENCES_KEY =
	'default/meeting_notifications_view_preferences'
